"use client";

import React from "react";
import {
  FaWhatsapp,
  FaPhoneAlt,
  FaEnvelope,
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaTwitter
} from "react-icons/fa";
import FlizeDev from "@/lib/flize";
import moment from "moment";


export default function Footer({ config }) {
  const theYear = moment().format("YYYY");
  if (!config) return null;
  return (
    <footer className="w-full bg-blue-700 text-white pt-12 pb-4">
      {/* Container principal com grid de 1440px */}
      <div className="max-w-[1440px] mx-auto grid grid-cols-1 md:grid-cols-3 gap-10 px-6 text-center md:text-left items-center">

        {/* Coluna 1 - Logo e Endereço */}
        <div className="flex flex-col items-center md:items-start">
          <img
            src="/assets/logopb.png"
            alt="Logo LG Centro Contábil"
            className="w-[300px] mb-4"
          />
          { config.configAddress && config.configAddress.length > 0 && (
          <div className="text-sm leading-relaxed max-w-[300px]">
            {config.configAddress.map((item, index) => (
              <div key={index}>{item}</div>
            ))}
          </div>
          )}
        </div>

        {/* Coluna 2 - Contatos */}
        <div className="flex flex-col items-center md:items-start space-y-4">
          { config.configPhone && config.configPhone.length > 0 && (
            <div className="flex items-center space-x-3">
              <FaWhatsapp className="text-xl" />
              <span>
                <a href={`tel:${config.configPhone.find(f => f.type === 'Celular').sanitized}`} title="Entrar em Contato">
                  { config.configPhone.find(f => f.type === 'Celular').label }
                </a>
              </span>
            </div>
          )}

          { config.configPhone && config.configPhone.length > 0 && (
          <div className="flex items-center space-x-3">
            <FaPhoneAlt className="text-xl" />
            <span>
              <a href={`tel:${config.configPhone.find(f => f.type === 'Fixo').sanitized}`} title="Entrar em Contato">
                { config.configPhone.find(f => f.type === 'Fixo').label }
              </a>
            </span>
          </div>
          )}

          { config.configEmail[0] && (
            <div className="flex items-center space-x-3">
              <FaEnvelope className="text-xl" />
              <span>
                <a href={`mailto:${config.configEmail[0]}`} title="Enviar E-mail">
                  { config.configEmail[0] }
                </a>
              </span>
            </div>
          )}
        </div>

        {/* Coluna 3 - Redes Sociais */}
        <div className="flex flex-col items-center md:items-start space-y-4">
          {config.configSocial.map((social, k) => (
            <a
              href={social.profile}
              target="_blank"
              rel="noopener noreferrer"
              key={k}
              className="group"
            >
              {social.unit === "F" && (
                <div className="flex items-center space-x-3 cursor-pointer hover:opacity-80 transition">
                  <FaFacebook className="text-2xl" />
                  <span>Facebook</span>
                </div>
              )}
              {social.unit === "I" && (
                <div className="flex items-center space-x-3 cursor-pointer hover:opacity-80 transition">
                  <FaInstagram className="text-2xl" />
                  <span>Instagram</span>
                </div>
              )}
              {social.unit === "L" && (
                <div className="flex items-center space-x-3 cursor-pointer hover:opacity-80 transition">
                  <FaLinkedin className="text-2xl" />
                  <span>LinkedIn</span>
                </div>
              )}
              {social.unit === "T" && (
                <div className="flex items-center space-x-3 cursor-pointer hover:opacity-80 transition">
                  <FaTwitter className="text-2xl" />
                  <span>Twitter</span>
                </div>
              )}
            </a>
          ))}
        </div>
      </div>

      {/* Linha inferior com logo Flize centralizado */}
      {/* Linha inferior com logo Flize centralizado */}
<div className="w-full uppercase text-sm border-t-1 text-white mt-10">
  <div className="container mx-auto">
    <div className="w-full flex flex-col items-center pt-4 text-center lg:flex-row lg:justify-between">
      {/* No mobile, o texto ficará centralizado. No desktop, alinhado à esquerda. */}
      <div className="flex-1 text-center lg:text-left mb-4 lg:mb-0">
        &copy; {process.env.NEXT_PUBLIC_APP_NAME} { theYear } - Todos os direitos reservados.
      </div>

      {/* No mobile, FlizeDev ficará centralizado. No desktop, alinhado à direita. */}
      <div className="flex-1 flex lg:justify-end">
        <FlizeDev />
      </div>
    </div>
  </div>
</div>
    </footer>
  );
}
